<ng-container *ngIf="questionGroup">
  <emperor-bp-sdk-accordion
    class="emperor-ui-coverage-accordion"
    [questionGroup]="questionGroup"
    [startPanelExpanded]="startPanelExpanded"
    >/</emperor-bp-sdk-accordion
  >
</ng-container>
